import OnboardingDetails from "manifest-core/classes/employerDashboard/onboardingDetails";
import User from "manifest-core/classes/employerDashboard/user";

export enum Actions {
  CLEAR_DATA = "CLEAR_DATA",
  FETCHING_USER_STATUS = "FETCHING_USER_STATUS",
  USER_STATUS_FETCHED = "USER_STATUS_FETCHED",
  FETCHING_ONBOARDING_STATUS = "FETCHING_ONBOARDING_STATUS",
  ONBOARDING_STATUS_FETCHED = "ONBOARDING_STATUS_FETCHED",
  FETCHING_PAYROLL_PROVIDERS = "FETCHING_PAYROLL_PROVIDERS",
  PAYROLL_PROVIDERS_FETCHED = "PAYROLL_PROVIDERS_FETCHED",
  FETCHING_RECORD_KEEPERS_LIST = "FETCHING_RECORD_KEEPERS_LIST",
  RECORD_KEEPERS_LIST_FETCHED = "RECORD_KEEPERS_LIST_FETCHED",
  UPDATE_INTEGRATION = "UPDATE_INTEGRATION",
}

export type Action =
  | { type: Actions.FETCHING_RECORD_KEEPERS_LIST }
  | { type: Actions.RECORD_KEEPERS_LIST_FETCHED; payload: string[] }
  | { type: Actions.CLEAR_DATA }
  | { type: Actions.FETCHING_USER_STATUS }
  | { type: Actions.USER_STATUS_FETCHED; payload: User | null }
  | { type: Actions.FETCHING_ONBOARDING_STATUS }
  | { type: Actions.ONBOARDING_STATUS_FETCHED; payload: OnboardingDetails }
  | { type: Actions.FETCHING_PAYROLL_PROVIDERS }
  | { type: Actions.PAYROLL_PROVIDERS_FETCHED; payload: string[] }
  | { type: Actions.UPDATE_INTEGRATION; payload: boolean };
